export default {
	'no-materials-to-show': 'لا يوجد مواد للعرض',
	'tab-products': 'المنتجات',
	'tab-received-samples': 'المواد المستلمة',
	'tab-unreceived-samples': 'المواد غير المستلمة',
	'stock-quantities': 'كميات المخزون',
	'sample-name': 'اسم المادة',
	remaining: 'متبقي',
	'no-samples-to-show': 'لا توجد مواد للعرض',
	'sort-by': 'ترتيب حسب',
	'no-unreceived-samples-to-show': 'لا توجد مواد للعرض',
	accept: 'تحديد ك مستلم',
	'unreceived-sample-accepted': 'تم استلام المادة بنجاح',
	warehouse: 'المستودع'
}
